// extracted by mini-css-extract-plugin
export var cmtNewText = "styles-module--cmt-new-text--ebce4";
export var cmtNewText__word = "styles-module--cmt-new-text__word--880e1";